import RoleRadioControlProps from './RoleRadioControlProps';

export default RoleRadioControlProps;
